import {
  call,
  put,
  throttle,
  debounce,
  select,
  delay
} from "redux-saga/effects";
import * as profileFieldsActions from "../actions/profileFieldsActions";
import {
  getCustomerCompanies,
  getCustomerCompaniesSearch
} from "../../api/profileFields";
import history from "../../../common/history";

const getActiveProfileId = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.profileId
  );
};

const getCompanyId = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.companyId
  );
};

function* getCustomerCompaniesSaga() {
  let companyId = yield select(getCompanyId);
  if (companyId) {
    try {
      const response = yield call(getCustomerCompanies, companyId);
      yield put(profileFieldsActions.getCustomerCompaniesSuccess(response));
    } catch (error) {
      yield put(profileFieldsActions.getCustomerCompaniesError(error));
    }
  } else {
    yield delay(500);
    companyId = yield select(getCompanyId);
    companyId
      ? yield put(profileFieldsActions.getCustomerCompanies())
      : history.push("/authorization/profiles");
  }
}

function* getCustomerCompaniesSearchSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    const { payload } = action;
    if (payload && payload.length > 1) {
      try {
        yield put(
          profileFieldsActions.getCustomerCompaniesSearchRequest(payload)
        );
        const response = yield call(
          getCustomerCompaniesSearch,
          activeProfileId,
          payload
        );
        yield put(
          profileFieldsActions.getCustomerCompaniesSearchSuccess(response)
        );
      } catch (error) {
        yield put(profileFieldsActions.getCustomerCompaniesSearchError(error));
      }
    } else {
      let value = yield select(
        state =>
          state.Common.ProfileFields.customerCompanies &&
          state.Common.ProfileFields.customerCompanies.value
      );
      if (value) {
        yield put(profileFieldsActions.getCustomerCompaniesSearchClear());
      }
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(
          profileFieldsActions.getCustomerCompaniesSearch(action.payload)
        )
      : history.push("/authorization/profiles");
  }
}

export function* profileFieldsConfigWatcher() {
  yield throttle(
    100,
    profileFieldsActions.getCustomerCompanies.toString(),
    getCustomerCompaniesSaga
  );
  yield debounce(
    800,
    profileFieldsActions.getCustomerCompaniesSearch.toString(),
    getCustomerCompaniesSearchSaga
  );
}
